import { FieldUpdatedEvent } from '../event/field-updated.event';
const fieldUpdatedProjections = {
    [FieldUpdatedEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default fieldUpdatedProjections;
//# sourceMappingURL=field-updated.projection.js.map